export default "/_next/static/images/4a4ee06b1050db09a157d6469bd440e5.png";